import axios from 'axios';
import { AccessInfo, PhotosResponse } from '../types';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api/v1';

// Create separate axios instance without auth interceptor for public access
const publicApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

export const accessService = {
  async verifyAccess(uuid: string): Promise<AccessInfo> {
    const response = await publicApi.get<AccessInfo>(`/access/${uuid}`);
    return response.data;
  },

  async getAccessiblePhotos(uuid: string, page = 1, limit = 50): Promise<PhotosResponse> {
    const response = await publicApi.get<PhotosResponse>(`/access/${uuid}/photos`, {
      params: { page, limit }
    });
    return response.data;
  },


  async downloadPhoto(uuid: string, photoId: number): Promise<Blob> {
    const response = await publicApi.get(`/access/${uuid}/photos/${photoId}/download`, {
      responseType: 'blob'
    });
    return response.data;
  },

  async downloadMultiplePhotos(uuid: string, photoIds: number[]): Promise<Blob> {
    const response = await publicApi.post(`/access/${uuid}/download`, 
      { photoIds },
      { responseType: 'blob' }
    );
    return response.data;
  },

  async requestUltraHDPhotos(uuid: string, photoIds: number[], email: string): Promise<{ success: boolean }> {
    const response = await publicApi.post(`/access/${uuid}/request-ultrahd`, {
      photoIds,
      email
    });
    return response.data;
  },
};